import { createContext } from 'react';
import { OpenDialog, CloseDialog } from './useDialogs';

const DialogsContext = createContext<{
  open: OpenDialog;
  close: CloseDialog;
} | null>(null);

export default DialogsContext;
